import { jsx as a, jsxs as l } from "react/jsx-runtime";
import { Dialog as t } from "@base-ui/react/dialog";
import { cn as r } from "../../lib/utils.js";
import { Button as d } from "./button.js";
import { XIcon as s } from "lucide-react";
function D({ ...o }) {
  return /* @__PURE__ */ a(t.Root, { "data-slot": "dialog", ...o });
}
function b({ ...o }) {
  return /* @__PURE__ */ a(t.Trigger, { "data-slot": "dialog-trigger", ...o });
}
function u({ ...o }) {
  return /* @__PURE__ */ a(t.Portal, { "data-slot": "dialog-portal", ...o });
}
function h({ ...o }) {
  return /* @__PURE__ */ a(t.Close, { "data-slot": "dialog-close", ...o });
}
function c({
  className: o,
  ...e
}) {
  return /* @__PURE__ */ a(
    t.Backdrop,
    {
      "data-slot": "dialog-overlay",
      className: r(
        "fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        o
      ),
      ...e
    }
  );
}
function v({
  className: o,
  children: e,
  showCloseButton: n = !0,
  ...i
}) {
  return /* @__PURE__ */ l(u, { children: [
    /* @__PURE__ */ a(c, {}),
    /* @__PURE__ */ l(
      t.Popup,
      {
        "data-slot": "dialog-content",
        className: r(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95",
          o
        ),
        ...i,
        children: [
          e,
          n && /* @__PURE__ */ l(
            t.Close,
            {
              "data-slot": "dialog-close",
              render: /* @__PURE__ */ a(
                d,
                {
                  variant: "ghost",
                  className: "absolute top-2 right-2",
                  size: "icon-sm"
                }
              ),
              children: [
                /* @__PURE__ */ a(
                  s,
                  {}
                ),
                /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function N({ className: o, ...e }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "dialog-header",
      className: r("flex flex-col gap-2", o),
      ...e
    }
  );
}
function C({
  className: o,
  showCloseButton: e = !1,
  children: n,
  ...i
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      "data-slot": "dialog-footer",
      className: r(
        "-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end",
        o
      ),
      ...i,
      children: [
        n,
        e && /* @__PURE__ */ a(t.Close, { render: /* @__PURE__ */ a(d, { variant: "outline" }), children: "Close" })
      ]
    }
  );
}
function y({ className: o, ...e }) {
  return /* @__PURE__ */ a(
    t.Title,
    {
      "data-slot": "dialog-title",
      className: r(
        "font-heading text-base leading-none font-medium",
        o
      ),
      ...e
    }
  );
}
function z({
  className: o,
  ...e
}) {
  return /* @__PURE__ */ a(
    t.Description,
    {
      "data-slot": "dialog-description",
      className: r(
        "text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground",
        o
      ),
      ...e
    }
  );
}
export {
  D as Dialog,
  h as DialogClose,
  v as DialogContent,
  z as DialogDescription,
  C as DialogFooter,
  N as DialogHeader,
  c as DialogOverlay,
  u as DialogPortal,
  y as DialogTitle,
  b as DialogTrigger
};
//# sourceMappingURL=dialog.js.map
